import EnrolmentsSerializer from './base';

export default class Log extends EnrolmentsSerializer {}
